enum DependQuantityOnCargoQuantityTransshipmentDirection {
	LOADING = 'loading',
	UNLOADING = 'unloading'
}

export default DependQuantityOnCargoQuantityTransshipmentDirection
